import { BaSeIcon } from "@base/react";
import "./index.scss";
import { useEffect, useState } from "react";
import CardResult from "../../../../components/card-results";
import {eventTag} from "../../../../services/utils";

const BodyResult = ({ data, call, eventRecommendations }) => {
  const [isOpenAc, setIsOpenAc] = useState(false);
  const [selected, setSelected] = useState("priority");
  const [size, setSize] = useState(window.innerWidth);
  const listContent = [];
  const listPriority = [];
 

  const handleAccordion = (item) => {
    setIsOpenAc(!isOpenAc);
    setSelected(item);
  };

  data.map((item) => {
    const recType = item.base_info.rec_type;
    recType === "content" && listContent.push(item);
    recType === "priority" && listPriority.push(item);
  });

  useEffect(() => {
    if (listPriority.length > 0) {
      setSelected("priority");
    } else {
      setSelected("content");
    }
  }, []);

  useEffect(() => {
    setIsOpenAc(false);
  }, [selected]);

  useEffect(() => {
    function handleRisize() {
      setSize(window.innerWidth);
      size <= 453 && setIsOpenAc(false);
    }
    window.addEventListener("resize", handleRisize);
    return () => window.removeEventListener("resize", handleRisize);
  }, []);

  return (
    <div className="content-modal-results">
      <span className="text">
        Com base na análise dos seus indicadores financeiros, preparamos algumas
        recomendações personalizadas para você. Elas te ajudarão a otimizar sua
        gestão e a tomar decisões ainda mais assertivas.
      </span>
      <div className="wrapper-priority">
        <div className={`list-btn ${isOpenAc && "show"}`}>
          <button
            className={`btn-default priority ${
              selected === "priority" ? "selected" : "not-selected"
            }`}
            onClick={() => {
              handleAccordion("priority")
              eventTag(eventRecommendations?.name, eventRecommendations?.category, eventRecommendations?.action, "Prioridades pra você")
            }}
          >
            Prioridades pra Você
            {selected === "priority" && (
              <div className="wrapper-icon">
                <BaSeIcon
                  color="#AB6005"
                  description="seta para a direita"
                  size={24}
                  name={
                    isOpenAc
                      ? "system/arrow-up-s-line"
                      : "system/arrow-down-s-line"
                  }
                />
              </div>
            )}
          </button>
          <button
            className={`btn-default content ${
              selected === "content" ? "selected" : "not-selected"
            }`}
            onClick={() => {
              handleAccordion("content")
              eventTag(eventRecommendations?.name, eventRecommendations?.category, eventRecommendations?.action, "Conteúdos complementares")
            }}
          >
            Conteúdos Complementares
            {selected === "content" && (
              <div className="wrapper-icon">
                <BaSeIcon
                  color="#2E5DE6"
                  description="seta para a direita"
                  size={24}
                  name={
                    isOpenAc
                      ? "system/arrow-up-s-line"
                      : "system/arrow-down-s-line"
                  }
                />
              </div>
            )}
          </button>
        </div>
      </div>
      <div className={`content-priority ${selected}`}>
        <p
          className={`text ${
            listPriority.length <= 0 ? "hiddenPriority" : "showPriority"
          } ${listContent.length <= 0 ? "hiddenContent" : "showContent"}`}
        >
          Com base no seu momento empresarial e nos desafios que identificamos,
          selecionamos conteúdos personalizados para te ajudar a trabalhar essas
          questões:
        </p>
        {selected === "priority" && listPriority.length <= 0 ? (
          <p className={`text-none-recommendations ${selected}`}>
            Ainda não encontramos um conteúdo para te ajudar.
          </p>
        ) : (
          ""
        )}
        {selected === "content" && listContent.length <= 0 ? (
          <p className={`text-none-recommendations ${selected}`}>
            Ainda não encontramos um conteúdo personalizado para te ajudar.
          </p>
        ) : (
          ""
        )}

        <div
          className={`list-cards ${selected} ${
            listPriority.length <= 0 ? "hiddenPriorityCards" : "showPriorityCards"
          } ${listContent.length <= 0 ? "hiddenContentCards" : "showContentCards"}`}
        >
          <CardResult
            selected={selected}
            eventRecommendations={eventRecommendations}
            list={selected === "priority" ? listPriority : listContent}
            callback={call}
          />
        </div>
      </div>
    </div>
  );
};

export default BodyResult;
